import type { TranslateLanguageCode, UploadQualityCode } from '@saesak/shared';

/**
 * 앱 설정 (v1.18) — 기기에만 저장되는 개인 설정.
 * 서버 계정 설정이 아니라 "이 기기에서 어떻게 쓸지"라 localStorage로 충분하다.
 */

const KEY = 'saesak-app-settings';

export interface AppSettings {
  /** 데이터(셀룰러) 연결에서 업로드할 때 한 번 확인 */
  uploadWifiCheck: boolean;
  /** 사진 업로드 화질 — 권장(긴 변 1920px 축소) / 원본 */
  uploadQuality: UploadQualityCode;
  /** 번역 기능 켜기 (다문화가정 지원, §5.28) */
  translateEnabled: boolean;
  /** 번역할 언어 */
  translateLang: TranslateLanguageCode;
}

const DEFAULTS: AppSettings = {
  uploadWifiCheck: true,
  uploadQuality: 'recommended',
  translateEnabled: false,
  translateLang: 'en',
};

export function getAppSettings(): AppSettings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<AppSettings>) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function setAppSettings(patch: Partial<AppSettings>): AppSettings {
  const next = { ...getAppSettings(), ...patch };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}
